import React, { useState } from "react";
import s from "./PopoverItems.module.scss";

import Delete from "../../../../../../global components/Icons/Delete/Delete";
import Edit from "../../../../../../global components/Icons/Edit/Edit";
import { useNavigate } from "react-router-dom";

import clsx from "clsx";
import { Oval } from "react-loader-spinner";

import useSWRMutation from "swr/mutation";
import {
  parseClientError,
  swrMutationFetcher,
  SwrMutationFetcherArgType,
} from "../../../../../../libs/api/Endpoints";
import { UseAuthToken } from "../../../../../../libs/api/userSession";
import { SuccessDataType } from "../../../../../../libs/api/types";
import { generateResult } from "../../../../../../global components/ResultModal/ResultModal";
import { generateConfirmation } from "../../../../../../global components/DestructiveModal/DestruvtiveModal";
import ViewUsage from "../ViewUsage";
import ReusableModal from "../../../../../../global components/Modal/Modal";
import EyeOpen from "../../../../../../global components/Icons/EyeOpen/EyeOpen";
interface PopOverItemsProps {
  keyValue: string; // Add a prop for the key value
  mutate?: () => void;
  code?: string;
  status: string;
}
function PopOverItems({ keyValue, mutate, code, status }: PopOverItemsProps) {
  const [showModal, setShow] = useState<boolean>(false);

  const { trigger: deleteCode, isMutating } = useSWRMutation(
    `api/admin/promo-codes/${keyValue}`,
    swrMutationFetcher
  );
  const token = UseAuthToken();
  const navigate = useNavigate();
  const deletePromoCode = async () => {
    try {
      const fetcherArg: SwrMutationFetcherArgType = {
        token: token,
        requestOption: {
          method: "DELETE",
        },
      };
      const result: SuccessDataType<any> = await deleteCode(fetcherArg);
      generateResult(
        "success",
        result.message.charAt(0).toUpperCase() + result.message.slice(1)
      );
      mutate && mutate();
    } catch (error) {
      const e = parseClientError(error);
      generateResult(
        "error",
        e.message.charAt(0) + e.message.slice(1) || "Something went wrong"
      );
    }
  };

  const handleModal = () => {
    setShow((prev) => !prev);
  };
  return (
    <>
      <ReusableModal
        handleModal={handleModal}
        isModalOpen={showModal}
        centered
        // width={500}
        // height={700}
        title={code ? code : ""}
      >
        <ViewUsage id={keyValue} />
      </ReusableModal>
      <div className={s.wrapper}>
        <span onClick={handleModal} className={clsx(s.PopOverItem)}>
          <EyeOpen fill="#240806" />
          <h5>View recipients</h5>
        </span>
        <span
          onClick={() =>
            status === "expired"
              ? generateResult(
                  "error",
                  "You can not edit an expired promo code."
                )
              : navigate(`/dashboard/promo-code/create/edit?codeId=${keyValue}`)
          }
          className={clsx(s.PopOverItem, s.drawer)}
        >
          <Edit width={18} height={18} />
          <h5>Edit</h5>
        </span>

        <span
          onClick={() =>
            generateConfirmation(
              "Delete promo code?",
              "Are you sure you want to delete this promo code",
              deletePromoCode,
              isMutating
            )
          }
          className={s.PopOverItem}
        >
          <Delete width={18} height={18} />
          <h5>Delete</h5>
          <Oval
            visible={isMutating}
            height="18"
            width="18"
            color="#d52b1e"
            ariaLabel="oval-loading"
          />
        </span>
      </div>
    </>
  );
}

export default PopOverItems;
